/*
 *
 * ProtectClientDataModal
 *
 * @version 1.0.0
 * @author Mauro La Barbera
 * @since 01-Aug-2025
*/

import ProtectClientDataModal from './ProtectClientDataModalContainer'

export default ProtectClientDataModal
